const SUPER_PROPERTY = 'Turnstile_failed';

function isPostHogEnabled(): boolean {
  return typeof window.posthog?.capture === 'function';
}

export function markTurnstileFailed(errorCode?: string): void {
  try {
    if (!isPostHogEnabled()) return;

    const posthog = window.posthog!;
    const properties: Record<string, unknown> = {
      [SUPER_PROPERTY]: true,
      turnstile_error_code: errorCode ?? null,
      page: typeof window !== 'undefined' ? window.location.pathname : null,
    };

    posthog.register?.({ [SUPER_PROPERTY]: true });
    posthog.people?.set?.({ [SUPER_PROPERTY]: true });

    const live = window.SERVER_URL === 'https://live.televeda.com';
    posthog.capture?.(live ? 'turnstile_failed' : 'turnstile_failed_staging', properties);
  } catch {
  }
}

export function clearTurnstileFailed(): void {
  try {
    if (!isPostHogEnabled()) return;

    const posthog = window.posthog!;
    posthog.unregister?.(SUPER_PROPERTY);
    posthog.people?.set?.({ [SUPER_PROPERTY]: false });
  } catch {
  }
}
